import { render, staticRenderFns } from "./PlanAccess.vue?vue&type=template&id=78ad78ff"
import script from "./PlanAccess.vue?vue&type=script&lang=js"
export * from "./PlanAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports